import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const PdfWrapper = styled.div`
	width: 0;
	height: 0;
	overflow: hidden;
`;
